import { t } from "@/mixins/i18nMixin";
import { STORE } from "@/store";
import { Router } from "@uuip/unified-ui-platform";
import { html } from "lit-html";
import style from "./ApsReportsBlock.scss";
const renderReportsComponent = () => {
    const { darkMode, visualRebrand, featureFlags } = STORE.app;
    return html `
    <agentx-wc-agent-performance-reports
      ?is-dark-theme=${darkMode}
      ?is-visual-rebrand=${visualRebrand}
      ?show-aps-agent-stats-by-queue=${featureFlags.isAgentStatisticsByQueueEnabled}
    ></agentx-wc-agent-performance-reports>
  `;
};
const ApsReportsBlock = () => {
    const { visualRebrand } = STORE.app;
    return new Router.RouterView.Block({
        template: html `
      <div class="${visualRebrand ? "aps-reports-view" : "agentx-wc-agent-performance-reports"}">
        ${visualRebrand
            ? html `
              <agentx-wc-panel-frame heading="${t("app:navigation.analytics")}">
                ${renderReportsComponent()}
              </agentx-wc-panel-frame>
            `
            : renderReportsComponent()}
      </div>
    `,
        styles: [style]
    });
};
export default ApsReportsBlock;
